import { styled, TableCell, TableRow, type TableRowProps } from '@shared/components';

interface SummaryTableRowProps extends TableRowProps {
  data: {
    calculate?: {
      easyQuestions: number | null;
      mediumQuestions: number | null;
      hardQuestions: number | null;
    };
    nonCalculate?: {
      easyQuestions: number | null;
      mediumQuestions: number | null;
      hardQuestions: number | null;
    };
    total?: string;
  };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderColor: theme.palette.grey[300],
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  ...theme.typography.body2Semibold,
}));

export default function SummaryTableRow(props: Readonly<SummaryTableRowProps>) {
  const { data, ...restProps } = props;
  const { calculate, nonCalculate, total } = data;
  const summary =
    (calculate?.easyQuestions ?? 0) +
    (calculate?.mediumQuestions ?? 0) +
    (calculate?.hardQuestions ?? 0) +
    (nonCalculate?.easyQuestions ?? 0) +
    (nonCalculate?.mediumQuestions ?? 0) +
    (nonCalculate?.hardQuestions ?? 0);

  return (
    <TableRow
      {...restProps}
      sx={{
        border: 'none',
        height: '48px',
        ':last-child': {
          borderRight: 'none',
          td: {
            borderBottom: 'none',
          },
        },
        backgroundColor: (theme) => theme.palette.grey[100],
        borderBottomLeftRadius: (theme) => theme.shape.rounded(2),
        borderBottomRightRadius: (theme) => theme.shape.rounded(2),
        ...restProps.sx,
      }}
    >
      <StyledTableCell
        align='right'
        sx={{
          p: (theme) => theme.spacing(2, 3),
          borderBottom: 'none',
        }}
      >
        รวมทั้งหมด
      </StyledTableCell>
      <StyledTableCell align='center'>{calculate?.easyQuestions ?? '-'}</StyledTableCell>
      <StyledTableCell align='center'>{calculate?.mediumQuestions ?? '-'}</StyledTableCell>
      <StyledTableCell align='center'>{calculate?.hardQuestions ?? '-'}</StyledTableCell>
      <StyledTableCell align='center'>{nonCalculate?.easyQuestions ?? '-'}</StyledTableCell>
      <StyledTableCell align='center'>{nonCalculate?.mediumQuestions ?? '-'}</StyledTableCell>
      <StyledTableCell align='center'>{nonCalculate?.hardQuestions ?? '-'}</StyledTableCell>
      <StyledTableCell align='center'>{total ?? (summary > 0 ? summary : '-')}</StyledTableCell>
    </TableRow>
  );
}
